export default "__VITE_ASSET__CbDf6Gnm__"